module.exports = __webpack_public_path__ + "static/media/golf-hero.e1af9a0b.jpg";